import React from 'react';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';

import { CenteredText } from '../styles/CenteredText';

function SectionInconformados() {
  return (
    <Section>
      <Block blockWidth="100%" textAlign="center" alignItems="center">
        <CenteredText
          variant="title"
          color="black"
          colorVariant="default"
          gutterBottom={2}
          intlKey="ABOUT_US.NONCONFORMISTS.TITLE"
        />
        <CenteredText
          variant="paragraph2"
          color="black"
          colorVariant="default"
          gutterBottom={1}
          maxWidth="30rem"
          intlKey="ABOUT_US.NONCONFORMISTS.PROBLEM"
        />
        <CenteredText
          variant="paragraph2"
          color="black"
          colorVariant="default"
          gutterBottom={1}
          maxWidth="30rem"
          intlKey="ABOUT_US.NONCONFORMISTS.BEGIN"
        />
        <CenteredText
          variant="paragraph2"
          color="black"
          colorVariant="default"
          gutterBottom={1}
          maxWidth="30rem"
          intlKey="ABOUT_US.NONCONFORMISTS.GOAL"
        />

        <CenteredText
          variant="paragraph2"
          color="black"
          colorVariant="default"
          maxWidth="30rem"
          intlKey="ABOUT_US.NONCONFORMISTS.TOGETHER"
        />
      </Block>
    </Section>
  );
}

export default React.memo(SectionInconformados);
